import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import Table from 'antd/lib/table';
import Tag from 'antd/lib/tag';
import Form from 'antd/lib/form';
import Select from 'antd/lib/select';
import Modal from 'antd/lib/modal';
import Divider from 'antd/lib/divider';
import Tooltip from 'antd/lib/tooltip';
import DatePicker from 'antd/lib/date-picker';
import Input from 'antd/lib/input';
import Card from 'antd/lib/card';
import Layout from 'antd/lib/layout';
import Menu from 'antd/lib/menu';
import Typography from 'antd/lib/typography';
import Space from 'antd/lib/space';
import QRCode from 'antd/lib/qrcode';
import Button from 'antd/lib/button';
import Checkbox from 'antd/lib/checkbox';
import Dropdown from 'antd/lib/dropdown';
import Avatar from 'antd/lib/avatar/avatar';
import Tabs from 'antd/lib/tabs';
import Steps from 'antd/lib/steps';
import message from 'antd/lib/message';
import Spin from 'antd/lib/spin';
import Skeleton from 'antd/lib/skeleton';
import Image from 'antd/lib/image';
import Upload from 'antd/lib/upload';
import Radio from 'antd/lib/radio';
import Empty from 'antd/lib/empty';
import InputNumber from 'antd/lib/input-number';
import Progress from 'antd/lib/progress';
import Popconfirm from 'antd/lib/popconfirm';
import FormProvider from 'antd/lib/form/Form';
import Alert from 'antd/lib/alert';
import AutoComplete from 'antd/lib/auto-complete';
import Result from 'antd/lib/result';
import Drawer from 'antd/lib/drawer';
import Watermark from 'antd/lib/watermark';
import Collapse from 'antd/lib/collapse';
import Slider from 'antd/lib/slider';
import Switch from 'antd/lib/switch';
import Tree from 'antd/lib/tree';
import  Breadcrumb from 'antd/lib/breadcrumb';
import Segmented from 'antd/lib/segmented';

import {
    PlusOutlined,
    SearchOutlined,
    MinusSquareOutlined,
    CloseOutlined,
    DeleteFilled,
    EditFilled,
    ExportOutlined,
    UserSwitchOutlined,
    ToolOutlined,
    ShoppingCartOutlined,
    CopyOutlined,
    UserAddOutlined,
    CheckCircleOutlined,
    CloseCircleOutlined,
    DownSquareOutlined,
    CaretDownOutlined,
    UserOutlined,
    LogoutOutlined, LoadingOutlined,
    PlusCircleFilled, CloudUploadOutlined,
    FileImageOutlined,
    PlusCircleTwoTone,
    CloseCircleFilled,
    PlusSquareOutlined,
    CloseSquareOutlined,
    PlusCircleOutlined,
    DoubleLeftOutlined,
    DownloadOutlined,
    MenuFoldOutlined,DoubleRightOutlined,EditOutlined,
    CheckOutlined,
    LockOutlined,
    DownOutlined,
    TeamOutlined,
    SettingFilled,
    MenuOutlined,
    EyeOutlined,
    MinusOutlined,
    DownCircleOutlined,
    UpCircleOutlined,
    UpOutlined,
    FileAddOutlined,
    DeleteOutlined,
    SettingOutlined,
    AuditOutlined,
    ReconciliationOutlined,
    ExclamationOutlined,
    ProjectOutlined 
}
    from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { format } from 'date-fns';
import {moment} from 'moment';
const {TextArea} = Input;

export {
    format,
    Row,
    Col,
    Form,
    Button,
    Input,
    Card,
    Layout,
    Menu,
    Typography,
    Space,
    QRCode,
    Table,
    Tag,
    Select,
    Modal,
    Divider,
    Tooltip,
    Checkbox,
    Switch,
    Tree,
    DatePicker,
    PlusOutlined,
    Avatar,
    Steps,
    Segmented,
    SearchOutlined,DownOutlined,MenuOutlined,
    MenuFoldOutlined,
    CloseOutlined, DeleteFilled, EditFilled, CopyOutlined,MinusSquareOutlined,
    Dropdown, Tabs, UserAddOutlined, CheckCircleOutlined, CloseCircleOutlined,TeamOutlined,
    DownSquareOutlined,
    CheckOutlined,
    message,
    SettingFilled,
    TextArea,
    Breadcrumb,
    CaretDownOutlined,
    Spin,
    Skeleton,
    ExportOutlined,
    UserSwitchOutlined,
    ToolOutlined,
    ShoppingCartOutlined,
    LogoutOutlined,
    LoadingOutlined,
    UserOutlined,
    PlusCircleFilled,
    LockOutlined,
    Upload,
    useDispatch, useSelector,
    CloudUploadOutlined,
    FileImageOutlined,
    Image,
    Radio, CloseCircleFilled,
    PlusCircleTwoTone,
    moment,
    Empty,
    PlusCircleOutlined,
    PlusSquareOutlined,
    CloseSquareOutlined,
    InputNumber,
    DoubleLeftOutlined,
    DownloadOutlined,
   
    Progress,
    Popconfirm,
    FormProvider,
    AutoComplete,
    Alert,
    Result,
    DoubleRightOutlined,
    Drawer,
    Watermark,
    EditOutlined,
    Collapse,
    Slider,
    EyeOutlined,
    MinusOutlined,
    DownCircleOutlined,
    UpCircleOutlined,
    UpOutlined,
    FileAddOutlined,
    DeleteOutlined, 
    SettingOutlined,
    AuditOutlined,
    ReconciliationOutlined,
    ExclamationOutlined,
    ProjectOutlined 
};